<template lang="pug">
  .main-container.relative
    lottie.animation(:options='optionsNotFound')
    .text-container.column.item-2.texts.absolute
      span.text-normal.gray.m-bottom-2
        | {{ $t('unauthorized.error', { statusCode }) }}
      span.title-medium.m-bottom-1
        | {{ $t('unauthorized.message') }}
      router-link.text-normal.bold.blue(:to='{name: routes.feed}')
        | {{ $t('unauthorized.back') }}
</template>

<script>
import { routes } from '../router'
import Lottie from 'vue-lottie'
import notFound from '@/assets/lottie/error404.json'

export default {
  props: {
    statusCode: { type: Number }
  },
  components: { Lottie },
  data() {
    return {
      optionsNotFound: { animationData: notFound, loop: false },
      routes
    }
  },
  computed: {
    code() {
      return this.$route.query.code
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/sizes';
@import 'src/scss/variables/colors';

.main-container {
  min-height: calc(100vh - #{$footer-height});
  padding-top: $navbar-height;
  width: 100%;
}
.animation {
  max-width: 1400px;
}
.text-container {
  left: 60%;
  top: 50%;
  transform: translateY(-50%);
  width: 224px;
}
</style>
